var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.96436 41.5947L6.64618 14.5947C6.84888 13.1082 8.11846 12 9.61867 12H38.3813C39.8815 12 41.1511 13.1082 41.3538 14.5947L45.0356 41.5947C45.2813 43.3959 43.8811 45 42.0631 45H5.93685C4.1189 45 2.71873 43.3959 2.96436 41.5947Z",
    fill: "#2A4384",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7184 12H9.28143C8.08707 12 7.07446 12.8782 6.90555 14.0606C6.69901 15.5064 7.82091 16.8 9.28143 16.8H38.7184C40.1789 16.8 41.3008 15.5064 41.0943 14.0606C40.9254 12.8782 39.9128 12 38.7184 12Z",
    fill: "#1F305E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 4.2C21.0177 4.2 18.6 6.61767 18.6 9.6V21.6C18.6 22.5941 17.7941 23.4 16.8 23.4C15.8059 23.4 15 22.5941 15 21.6V9.6C15 4.62944 19.0294 0.600002 24 0.600002C28.9706 0.600002 33 4.62944 33 9.6V21.6C33 22.5941 32.1941 23.4 31.2 23.4C30.2059 23.4 29.4 22.5941 29.4 21.6V9.6C29.4 6.61767 26.9823 4.2 24 4.2Z",
    fill: "#1F305E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShoppingBag);
export default __webpack_public_path__ + "static/media/icon-shopping-bag.2b2128c43623a841fdc094b932aba4e7.svg";
export { ForwardRef as ReactComponent };